import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import { getCsrfToken } from "@/components/common/utils/utils";
import {getAllBranches, useGetAllBranches} from "@/shared/api/client/company-resource";
import { useGetLoginLogo } from "@/shared/api/client/appearance-controller";

const LoginFormView = () => {
    const { data: logoData } = useGetLoginLogo();
    const logoPath = typeof logoData === 'string' ? logoData : logoData?.data || '/images/login.png';

    const {
        data: branchesResponse,
        isLoading: isBranchesLoading,
        isError: isBranchesError,
        error: branchesError
    } = useGetAllBranches();

    if (isBranchesLoading) {
        return <div className="flex justify-center items-center min-h-screen">Loading...</div>;
    }

    if (isBranchesError) {
        return (
            <div className="flex justify-center items-center min-h-screen text-red-600">
                {(branchesError as any)?.message || 'Failed to load branches'}
            </div>
        );
    }

    const branches = branchesResponse;

    if (!branches?.length) {
        return <div className="flex justify-center items-center min-h-screen">No branches available</div>;
    }

    return (
        <div className="flex w-full flex-col mx-auto max-w-md px-4 py-8">
            <div className="md:hidden flex flex-col justify-center items-center w-full mb-8">
                <Image
                    src={logoPath}
                    alt="Company Logo"
                    className="max-w-[200px]"
                />
            </div>

            <form
                method="POST"
                action="/login"
                className="w-full"
            >
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-semibold">Sign In</h1>
                </div>

                <input
                    type="hidden"
                    name="_csrf"
                    value={getCsrfToken()}
                />

                {branches.length > 1 ? (
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-2">
                            Branch
                            <select
                                name="branch"
                                required
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
                                defaultValue=""
                            >
                                <option value="" disabled>Select your branch</option>
                                {branches.map((branch) => (
                                    <option key={branch.branch} value={branch.branch}>
                                        {branch.branchName}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                ) : (
                    <input
                        type="hidden"
                        name="branch"
                        value={branches[0].branch}
                    />
                )}

                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2">
                        Username
                        <input
                            type="text"
                            name="username"
                            required
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
                        />
                    </label>
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium mb-2">
                        Password
                        <input
                            type="password"
                            name="password"
                            required
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2"
                        />
                    </label>
                </div>

                <button
                    type="submit"
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md"
                >
                    Sign In
                </button>
            </form>
        </div>
    );
};

export default LoginFormView;